import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { SceneSection } from './Journey';
import { StaticSlot } from './StaticVisuals';
import { scrollToId } from '../lib/gsap';

export const SlotMachineSection = () => {
  const { t } = useLanguage();
  const stats = [
    { v: '10K+', k: 'slotMachine.statsGames' },
    { v: '100+', k: 'slotMachine.statsProviders' },
    { v: '99.9%', k: 'slotMachine.statsUptime' },
  ];

  return (
    <SceneSection scene={1} id="experience" testId="slot-machine-section" staticVisual={<StaticSlot />}>
      <p className="eyebrow">{t('slotMachine.badge')}</p>
      <h2 className="display-xl mt-8 text-[clamp(2.4rem,4.8vw,4.8rem)]">
        {t('slotMachine.title1')} <span className="italic text-[#C8AA73]">{t('slotMachine.title2')}</span>
      </h2>
      <p className="mt-8 max-w-[520px] text-base sm:text-lg leading-relaxed text-[#ABA59A]">
        {t('slotMachine.description')} <span className="text-[#E8D6AF]">{t('slotMachine.games')}</span>{t('slotMachine.descEnd')}
      </p>
      <div className="mt-10 flex flex-wrap gap-3 sm:gap-4">
        <button onClick={() => scrollToId('contact')} className="btn-primary min-h-[48px]" data-testid="slot-request-demo">{t('slotMachine.requestDemo')}</button>
        <Link to="/services/aggregator" className="btn-secondary min-h-[48px]" data-testid="slot-explore-games">{t('slotMachine.exploreGames')}</Link>
      </div>
      <dl className="mt-14 grid grid-cols-3 border-t border-[#F4F0E8]/10">
        {stats.map((s, i) => (
          <div key={s.k} className={`pt-6 ${i ? 'pl-4 border-l border-[#F4F0E8]/10' : 'pr-2'}`}>
            <dt className="font-display text-2xl sm:text-4xl text-[#F4F0E8]">{s.v}</dt>
            <dd className="mt-2 text-xs sm:text-sm text-[#7C776E]">{t(s.k)}</dd>
          </div>
        ))}
      </dl>
    </SceneSection>
  );
};

export default SlotMachineSection;
